import * as THREE from "three";



export default function setCameraAndControls(threeViewer: any, product: THREE.Group): void {
    const box = new THREE.Box3().setFromObject(product);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());

    // Target the product's REAL centre, not half its height.
    //
    // `size.y / 2` is the centre only when the product's base sits at y = 0 — true of a
    // tumbler, and the assumption baked in here. A model that straddles the origin gets a
    // target well above its middle, and hangs below centre on screen for it.
    //
    // For anything already modelled base-at-origin the two are identical, so no existing
    // product moves.

    threeViewer.controls.setLookAt(
        0, center.y, size.z * 8, // Camera position
        0, center.y, 0,           // Target position
        true
    );

    const maxWidth = Math.max(size.x, size.z);
    threeViewer.controls.minDistance = maxWidth * 1.5;
    threeViewer.controls.maxDistance = maxWidth * 10;

    threeViewer.productSize = size;
    threeViewer.center = center;
}